import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Gallery Composable
 * Bietet Zugriff auf Gallery-Bilder mit Apartment-Relationen
 */
export function useGallery() {
  const apiStore = useApiStore()

  return {
    // Data
    gallery: computed(() => apiStore.gallery),
    loading: computed(() => apiStore.galleryLoading),
    error: computed(() => apiStore.galleryError),
    hasGallery: computed(() => apiStore.hasGallery),

    // Methods
    getByApartmentSlug: computed(() => apiStore.getGalleryByApartmentSlug),
    getByApartmentId: computed(() => apiStore.getGalleryByApartmentId),
    load: () => apiStore.loadGallery()
  }
}